import { snkd } from "@/api/api";

import send from "@/api/lib";

// 作物
export const cropPrice = {
  /***
   * @description 农作物价格趋势
   * @param dateListStr (Array[string], optional): 时间
   * @param nccropId (integer, optional): nc农作物id
   * @param provinceId (string, optional): 省id
   * @returns {Promise<*>}
   */
  listService(
    { dateListStr, nccropId, provinceId } = {
      dateListStr: "",
      nccropId: "",
      provinceId: "",
    }
  ) {
    return send.post(snkd.operate.cropPrice.list, {
      dateListStr,
      nccropId,
      provinceId,
    });
  },
  /***
   * @description 农作物列表（价格趋势专用）
   * @returns {Promise<*>}
   */
  listOfCropService() {
    return send.post(snkd.operate.cropPrice.listOfCrop);
  },
};

export const crop = {
  /***
   * @description 农作物列表（价格趋势专用）
   * @returns {Promise<*>}
   */
  listService(params) {
    return send.post(snkd.operate.crop.list, params);
  },
};

// 运营商配置：客服微信二维码(contactWeixinImg)、联系电话(contactPhone) 等
export const subject = {
  /***
   * @description 运营商（当前域名所属）配置信息
   * @returns {Promise<*>}
   */
  getService() {
    return send.post(snkd.operate.subject.get, {});
  },
};
